/* Darvue storefront behaviour */
(function () {
  'use strict';

  var cfg = window.Darvue || {};
  var addUrl = (cfg.cartAddUrl || '/cart/add') + '.js';
  var cartUrl = cfg.cartUrl || '/cart';

  function addItems(items, button, errorEl) {
    var merged = {};
    items.forEach(function (id) {
      if (!id) return;
      merged[id] = (merged[id] || 0) + 1;
    });
    var payload = Object.keys(merged).map(function (id) {
      return { id: Number(id), quantity: merged[id] };
    });
    if (!payload.length) return;
    if (button) button.disabled = true;
    if (errorEl) errorEl.textContent = '';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: payload })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
          return data;
        });
      })
      .then(function () {
        window.location.href = cartUrl;
      })
      .catch(function (err) {
        if (errorEl) errorEl.textContent = err.message + ' Please try another shade.';
        if (button) button.disabled = false;
      });
  }

  /* Product page */
  document.querySelectorAll('[data-dv-product]').forEach(function (root) {
    var offers = Array.prototype.slice.call(root.querySelectorAll('[data-dv-offer]'));
    var priceNow = root.querySelector('[data-dv-price-now]');
    var priceWas = root.querySelector('[data-dv-price-was]');
    var priceSave = root.querySelector('[data-dv-price-save]');
    var cartBtn = root.querySelector('[data-dv-add]');
    var cartLabel = root.querySelector('[data-dv-add-label]');
    var errorEl = root.querySelector('[data-dv-error]');
    var shadeName = root.querySelector('[data-dv-shade-name]');

    function activate(offer) {
      offers.forEach(function (o) {
        var on = o === offer;
        o.classList.toggle('is-active', on);
        var head = o.querySelector('[data-dv-offer-head]');
        if (head) head.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (priceNow) priceNow.textContent = offer.getAttribute('data-price');
      if (priceWas) priceWas.textContent = offer.getAttribute('data-was');
      if (priceSave) priceSave.textContent = offer.getAttribute('data-save');
      if (cartLabel) cartLabel.textContent = offer.getAttribute('data-price');
    }

    offers.forEach(function (offer) {
      var head = offer.querySelector('[data-dv-offer-head]');
      if (head) head.addEventListener('click', function () { activate(offer); });
    });

    root.querySelectorAll('[data-dv-pill]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var id = pill.getAttribute('data-variant');
        root.querySelectorAll('[data-dv-pill]').forEach(function (p) {
          p.setAttribute('aria-pressed', p === pill ? 'true' : 'false');
        });
        root.querySelectorAll('select[data-dv-pick]').forEach(function (sel) {
          sel.value = id;
        });
        if (shadeName) shadeName.textContent = pill.getAttribute('data-name');
        var img = pill.getAttribute('data-image');
        var main = root.querySelector('[data-dv-main-image]');
        if (img && main) {
          main.src = img;
          main.removeAttribute('srcset');
        }
      });
    });

    root.querySelectorAll('[data-dv-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var main = root.querySelector('[data-dv-main-image]');
        if (!main) return;
        main.src = thumb.getAttribute('data-src');
        main.removeAttribute('srcset');
        main.alt = thumb.getAttribute('data-alt') || '';
        root.querySelectorAll('[data-dv-thumb]').forEach(function (t) {
          t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
        });
      });
    });

    if (cartBtn) {
      cartBtn.addEventListener('click', function () {
        var active = root.querySelector('[data-dv-offer].is-active') || offers[0];
        if (!active) return;
        var ids = Array.prototype.map.call(active.querySelectorAll('[data-dv-pick]'), function (el) {
          return el.value;
        });
        addItems(ids, cartBtn, errorEl);
      });
    }
  });

  /* Kit (homepage) */
  document.querySelectorAll('[data-dv-kit]').forEach(function (kit) {
    var btn = kit.querySelector('[data-dv-kit-add]');
    var errorEl = kit.querySelector('[data-dv-error]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var ids = [];
      kit.querySelectorAll('select[data-dv-kit-pick]').forEach(function (sel) {
        ids.push(sel.value, sel.value);
      });
      addItems(ids, btn, errorEl);
    });
  });
})();
